module.exports = __webpack_public_path__ + "img/21_61.97660887.png";